import moment from 'moment';
import { IMyAudit, IMyAuditSections } from '../../../@types/myAudit';

export const convertPayloadToMyAudit = (
  tabContent: IMyAudit,
  startDate?: Date | string,
  dateTime?: Date | string,
  startDateRange?: Date | string,
  endDateRange?: Date | string
) => {
  const setDatesToPayload = (section: IMyAuditSections) => {
    switch (section && section.dateTimeFormat) {
      case 'date':
        section.fromDate = startDate;
        break;
      case 'dateTime':
        section.fromDate = dateTime && moment(dateTime).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        break;
      case 'dateOnlyRange':
        section.fromDate = startDateRange;
        section.toDate = endDateRange;
        break;
      default:
        break;
    }
  };

  return (
    tabContent &&
    tabContent.myAuditSections.map((section) => {
      setDatesToPayload(section);
      return {
        sectionId: section.id,
        comments: section.comments,
        outletName: section.outletName,
        roomNumber: section.roomNumber,
        fromDate: section.fromDate || null,
        toDate: section.toDate || null,
        tagged: section.tagged && section.tagged.map((tagged) => tagged.id),
        mealPeriod: section.mealPeriod || undefined,
        standardScore: section.standards.map((standard) => {
          return {
            templateStandardId: standard.id,
            comments: standard.comments,
            response: Number.isNaN(standard.score as number)
              ? null
              : standard.score,
          };
        }),
      };
    })
  );
};

export const validateMyAuditDateRange = (
  tabContent: IMyAudit,
  startDateRange?: Date | string,
  endDateRange?: Date | string
): boolean => {
  const hasError = tabContent && tabContent.myAuditSections.some((section) => {
    return (
      section && section.dateTimeFormat && section.dateTimeFormat === 'dateOnlyRange' &&
      (startDateRange || endDateRange) &&
      (!startDateRange || !endDateRange)
    );
  });

  return hasError;
};
